export interface Faq {
  q: string;
  a: string;
  category: string;
}

export const faqs: Faq[] = [
  {
    category: '题材分类',
    q: '韩漫漫画网都有哪些题材分类？',
    a: '本站聚合奇幻漫画、校园漫画、恋爱漫画等热门题材，每个题材下还配有更细的标签，例如异世界、龙族、社团、双向暗恋等，方便你按喜好快速定位想看的作品。',
  },
  {
    category: '题材分类',
    q: '如何快速找到我想看的韩漫类型？',
    a: '你可以在首页使用关键词搜索，也可以直接进入奇幻、校园、恋爱任意一个分类页，再结合题材标签和连载状态筛选，几步之内就能锁定心头好。',
  },
  {
    category: '更新与阅读',
    q: '作品的更新频率如何？',
    a: '连载中的作品会持续更新，首页和分类页都会标注每部作品的最新更新时间与章节数，方便你随时掌握追更进度。',
  },
  {
    category: '更新与阅读',
    q: '漫画是免费阅读的吗？',
    a: '本站以题材聚合与内容推荐为主，让你先快速找到喜欢的韩漫类型。具体阅读方式以作品原始平台为准，本站不代收费、不虚构会员权益。',
  },
  {
    category: '内容与安全',
    q: '为什么选择在韩漫漫画网找漫画？',
    a: '因为分类清晰直达、题材聚合度高，不用在多个平台之间反复搜索，就能一站找齐奇幻、校园、恋爱等热门题材，节省大量筛选时间。',
  },
  {
    category: '内容与安全',
    q: '页面加载和访问是否顺畅？',
    a: '我们持续优化页面结构与图片加载，减少多余脚本，让你在手机、平板和电脑上都能获得轻快流畅的浏览体验。',
  },
];